// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ulra","colBig":"styles_colBig__3DOZy","colSmall":"styles_colSmall__1Y3ds","shopifyNameWrapper":"styles_shopifyNameWrapper__2PUKY"};